import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { lockOpen } from 'ionicons/icons';
import { IonCard, IonRow, IonCol, IonGrid, IonIcon } from '@ionic/vue';

import { toRefs } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'LockedCard',
  props: {
    title: null,
    subtitle: null
  },
  setup(__props: any) {

const props = __props as {
  title: string;
  subtitle: string;
}



const { title, subtitle } = toRefs(props);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonCard), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonGrid), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonRow), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonCol), { class: "ion-padding ion-text-center" }, {
                default: _withCtx(() => [
                  _createElementVNode("h3", null, [
                    _createVNode(_unref(IonIcon), {
                      icon: _unref(lockOpen),
                      class: "ion-margin-end"
                    }, null, 8, ["icon"]),
                    _createElementVNode("span", null, _toDisplayString(_unref(title)), 1)
                  ]),
                  _createElementVNode("p", null, _toDisplayString(_unref(subtitle)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})